//

import { formatDate, parseDate } from "devextreme/localization";
//import { forEach } from '@angular/router/src/utils/collection';

    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

    // More info: http://frhagn.github.io/Typewriter/

export interface ISearchReportResponse {
  reportName?: string | undefined;
}
export class SearchReportResponseBase implements ISearchReportResponse {
  reportName?: string | undefined;
  constructor(data?: ISearchReportResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.reportName = data["reportName"];
  }
  static fromJS(data: any): SearchReportResponseBase {
    data = typeof data === 'object' ? data : {};
    let result = new SearchReportResponseBase();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportName"] = this.reportName;
  }

}

export class AuthResultVM {
  public credentialGuid: string;
  public success: number;
  public msg: string;
  public totAmount: number;
}

export interface IAlphaSearchRowVM {
  // $LoudName
  last_name: string | undefined;
  // $LoudName
  first_name?: string | undefined;
}

export class AlphaSearchRowVM implements IAlphaSearchRowVM {


  last_name: string | undefined;
  first_name?: string | undefined;
  
  constructor(data?: IAlphaSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.last_name = data["last_name"];
      this.first_name = data["first_name"];
    }
  }
  static fromJS(data: any): AlphaSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new AlphaSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["last_name"] = this.last_name;
    data["first_name"] = this.first_name;
    
    return data;
  }

}

export interface IAlphaSearchQuery {
  last_name: string | undefined;
  first_name?: string | undefined;
  roleId?: number | undefined;
}

export class GetAlphaSearchQuery implements IAlphaSearchQuery {
  last_name: string | undefined;
  first_name?: string | undefined;
  roleId?: number | undefined;

  constructor(data?: IAlphaSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.last_name = data["last_name"];
      this.first_name = data["first_name"];
      this.roleId = data["roleId"];
    }
  }

  static fromJS(data: any): GetAlphaSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetAlphaSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["last_name"] = this.last_name;
    data["first_name"] = this.first_name;
    data["roleId"] = this.roleId;
    return data;
  }
}


export interface IAlphaSearchListVM {
  alphaSearchRows?: AlphaSearchRowVM[] | undefined;

}

export class AlphaSearchListVM implements IAlphaSearchListVM{

  alphaSearchRows?: AlphaSearchRowVM[] | undefined;
  constructor(data?: IAlphaSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["alphaSearchRows"])) {
        this.alphaSearchRows = [] as any;
        for (let item of data["alphaSearchRows"])
          this.alphaSearchRows!.push(AlphaSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): AlphaSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new AlphaSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.alphaSearchRows)) {
      data["AaphaSearchRows"] = [];
      for (let item of this.alphaSearchRows)
        data["alphaSearchRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface IValidMachine {
  validMachine?: string | undefined;
  validStation?: string | undefined;
  machineLocation: number;
}

export class ValidMachine implements IValidMachine {
  validMachine?: string | undefined;
  validStation?: string | undefined;
  machineLocation: number = 0;
}


export class CityTownVM {
        
        // $LoudName
        public townAbbrev: string ;
        // $LoudName
        public townName: string ;
}
export class DocTypeVM {
        
    // $LoudName
    public docCode: string ;
    // $LoudName
    public docName: string ;
}
export class DocCatVM {
        
    // $LoudName
    public docCatCode: string ;
    // $LoudName
    public docCatName: string ;
}
export class RecNameSearchResultVM {
        
    // $LoudName
    public rsHeader: RSHeaderVM ;
    // $LoudName
    public recNameSearchRows: RecNameSearchRowVM[] ;
}
export class RSHeaderVM {
        
    // $LoudName
    public label1: string ;
    // $LoudName
    public text1: string ;
    // $LoudName
    public label2: string ;
    // $LoudName
    public text2: string ;
    // $LoudName
    public label3: string ;
    // $LoudName
    public text3: string ;
    // $LoudName
    public label4: string ;
    // $LoudName
    public text4: string ;
    // $LoudName
    public label5: string ;
    // $LoudName
    public text5: string ;
    // $LoudName
    public label6: string ;
    // $LoudName
    public text6: string ;
}

export interface IRecNameSearchRowVM {
  // $LoudName
  docID?: number | undefined;
  // $LoudName
  unparsedName?: string | undefined;
  // $LoudName
  role?: string | undefined;
  // $LoudName
  recordDate?: Date | undefined;
  // $LoudName
  address?: string | undefined;
  // $LoudName
  cityTown?: string | undefined;
  // $LoudName
  docType?: string | undefined;
  // $LoudName
  recLandBook?: string | undefined;
  // $LoudName
  recLandPage?: string | undefined;
  // $LoudName
  amount?: number | undefined;
  // $LoudName
  role2?: string | undefined;
  // $LoudName
  recLandBP?: string | undefined;
  // $LoudName
  lname?: string | undefined;
  fname?: string | undefined;
  revParty?: string | undefined;
  idxPage?: number | undefined;
  idxByPage?: number | undefined;
}

    export class RecNameSearchRowVM implements IRecNameSearchRowVM {
        
        // $LoudName
        public docID?: number | undefined;
        // $LoudName
        public unparsedName?: string | undefined ;
        // $LoudName
        public role?: string | undefined;
        // $LoudName
        public recordDate?: Date | undefined;
        // $LoudName
        public address?: string | undefined;
        // $LoudName
        public cityTown?: string | undefined;
        // $LoudName
        public docType?: string | undefined;
        // $LoudName
        public recLandBook?: string | undefined;
        // $LoudName
        public recLandPage?: string | undefined;
        // $LoudName
        public amount?: number | undefined;
        // $LoudName
        public role2?: string | undefined;
        // $LoudName
        public recLandBP?: string | undefined;
        public lname?: string | undefined;
        public fname?: string | undefined;
        public revParty?: string | undefined;
        public idxPage?: number | undefined;
        public idxByPage?: number | undefined;

      constructor(data?: IRecNameSearchRowVM) {
        if (data) {
          for (var property in data) {
            if (data.hasOwnProperty(property))
              (<any>this)[property] = (<any>data)[property];
          }
        }
      }
      init(data?: any) {
        this.docID = data["docID"];
        this.unparsedName = data["unparsedName"];
        this.role = data["role"];
        this.cityTown = data["cityTown"];
        this.recordDate = new Date();
        this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
        this.docType = data["docType"];
        this.address = data["address"];
        this.recLandBook = data["recLandBook"];
        this.recLandPage = data["recLandPage"];
        this.amount = data["amount"];
        this.role2 = data["role2"];
        this.recLandBP = data["recLandBP"];
        this.lname = data["lname"];
        this.fname = data["fname"];
        this.revParty = data["revParty"];
        this.idxPage = data["idxPage"];
        this.idxByPage = data["idxByPage"];
      }

      static fromJS(data: any): RecNameSearchRowVM {
        data = typeof data === 'object' ? data : {};
        let result = new RecNameSearchRowVM();
        result.init(data);
        return result;
      }
      toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docID"] = this.docID;
        data["unparsedName"] = this.unparsedName;
        data["role"] = this.role;
        data["cityTown"] = this.cityTown;
        data["recordDate"] = formatDate(this.recordDate, "shortDate");
        data["docType"] = this.docType;
        data["address"] = this.address;
        data["recLandBook"] = this.recLandBook;
        data["recLandPage"] = this.recLandPage;
        data["amount"] = this.amount;
        data["role2"] = this.role2;
        data["recLandBP"] = this.recLandBP;
        data["lname"] = this.lname;
        data["fname"] = this.fname;
        data["revParty"] = this.revParty;
        data["idxPage"] = this.idxPage;
        data["idxByPage"] = this.idxByPage;
      }
}

export interface IGetProperySearchQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  group?: number | undefined;
}

export class GetProperySearchQuery implements IGetProperySearchQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  group?: number | undefined;

  constructor(data?: IGetProperySearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.lastName = data["lastName"];
      this.firstName = data["firstName"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.group = data["group"];
    }
  }
  static fromJS(data: any): GetProperySearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetProperySearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["group"] = this.group;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    return data;
  }

}

export interface IGetPropertySearchReportQuery extends IGetProperySearchQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;
  filterExpression?: string | undefined;

}

export class GetPropertySearchReportQuery extends GetProperySearchQuery implements IGetPropertySearchReportQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;
  filterExpression?: string | undefined;

  constructor(data?: IGetPropertySearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }

  static fromJS(data: any) {
    data = typeof data === 'object' ? data : {};
    let result = new GetPropertySearchReportQuery();
    result.init(data);
    return result;

  }

  init(data?: any) {
    this.lastName = data["lastName"];
    this.firstName = data["firstName"];
    this.fromDate = data["fromDate"];
    this.toDate = data["toDate"];
    this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
    this.group = data["group"];
    this.sortBy = [...(data["sortBy"] as string[])];
    this.sortDirection = data["sortDirection"];
    this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    this.filterExpression = data["filterExpression"];
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["group"] = this.group;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;


    return data;
  }

}

export class GetPropertySearchReportResponse extends SearchReportResponseBase { }

export interface IGetRecNameSearchQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  lastName2?: string | undefined;
  firstName2?: string | undefined;
  roleId2?: number | undefined;
  contains?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
}

export class GetRecNameSearchQuery implements IGetRecNameSearchQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  lastName2?: string | undefined;
  firstName2?: string | undefined;
  roleId2?: number | undefined;
  contains?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;

  constructor(data?: IGetRecNameSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.lastName = data["lastName"];
      this.firstName = data["firstName"];
      this.roleId = data["roleId"];
      this.lastName2 = data["lastName2"];
      this.firstName2 = data["firstName2"];
      this.roleId2 = data["roleId2"];
      this.contains = data["contains"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
    }
  }

  static fromJS(data: any): GetRecNameSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecNameSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["roleId"] = this.roleId;
    data["lastName2"] = this.lastName2;
    data["firstName2"] = this.firstName2;
    data["roleId2"] = this.roleId2;
    data["contains"] = this.contains;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    return data;
  }
}
export interface IRecNameSearchListVM {
  recNameSearchRows?: RecNameSearchRowVM[] | undefined;
}
export class RecNameSearchListVM implements IRecNameSearchListVM {
  recNameSearchRows?: RecNameSearchRowVM[] | undefined;
  constructor(data?: IRecNameSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["recNameSearchRows"])) {
        this.recNameSearchRows = [] as any;
        for (let item of data["recNameSearchRows"])
          this.recNameSearchRows!.push(RecNameSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RecNameSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecNameSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recNameSearchRows)) {
      data["recNameSearchRows"] = [];
      for (let item of this.recNameSearchRows)
        data["recNameSearchRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface IRecDateSearchRowVM {
  docID?: number | undefined;
  firstGrantor?: string | undefined;
  firstGrantee?: string | undefined;

  //// $LoudName
  //public unparsedName: string;
  //// $LoudName
  //public role: string;
  // $LoudName
  recordDate?: Date | undefined;
  // $LoudName
  unparsedAddress?: string | undefined;
  // $LoudName
  cityTown?: string | undefined;
  // $LoudName
  docType?: string | undefined;
  // $LoudName
  recLandBook?: string | undefined;
  // $LoudName
  recLandPage?: string | undefined;
  // $LoudName
  amount?: number | undefined;
  //// $LoudName
  //public role2: string;
  // $LoudName
  recLandBP?: string | undefined;
  lname?: string | undefined;
}
export class RecDateSearchRowVM implements IRecDateSearchRowVM {
  // $LoudName
  public docID?: number | undefined;
  public firstGrantor?: string | undefined;
  public firstGrantee?: string | undefined;

  //// $LoudName
  //public unparsedName: string;
  //// $LoudName
  //public role: string;
  // $LoudName
  public recordDate?: Date | undefined;
  // $LoudName
  public unparsedAddress?: string | undefined;
  // $LoudName
  public cityTown?: string | undefined;
  // $LoudName
  public docType?: string | undefined;
  // $LoudName
  public recLandBook?: string | undefined;
  // $LoudName
  public recLandPage?: string | undefined;
  // $LoudName
  public amount?: number | undefined;
  //// $LoudName
  //public role2: string;
  // $LoudName
  public recLandBP?: string | undefined;
  public lname?: string | undefined;

  constructor(data?: IRecDateSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    this.docID = data["docID"];
    this.firstGrantor = data["firstGrantor"];
    this.firstGrantee = data["firstGrantee"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.unparsedAddress = data["unparsedAddress"];
    this.cityTown = data["cityTown"];
    this.docType = data["docType"];
    this.recLandBook = data["recLandBook"];
    this.recLandPage = data["recLandPage"];

    this.amount = data["amount"];
    this.recLandBP = data["recLandBP"];
    this.lname = data["lname"];
  }
  static fromJS(data: any): RecDateSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecDateSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docID"] = this.docID;
    data["firstGrantor"] = this.firstGrantor;
    data["firstGrantee"] = this.firstGrantee;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");
    data["unparsedAddress"] = this.unparsedAddress;
    data["cityTown"] = this.cityTown;
    data["docType"] = this.docType;
    data["recLandBook"] = this.recLandBook;
    data["recLandPage"] = this.recLandPage;
    data["amount"] = this.amount;
    data["recLandBP"] = this.recLandBP;
    data["lname"] = this.lname;
  }

}



export interface IGetRecDateSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
}

export class GetRecDateSearchQuery implements IGetRecDateSearchQuery {
  public fromDate?: string | undefined;
  public toDate?: string | undefined;
  public towns?: string[] | undefined;
  public doctypes?: string[] | undefined;

  constructor(data?: IGetRecDateSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
    }
  }

  static fromJS(data: any): GetRecDateSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecDateSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    return data;
  }

}

export interface IGetRecDateSearchReportQuery extends IGetRecDateSearchQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;

}
export class GetRecDateSearchReportQuery extends GetRecDateSearchQuery implements IGetRecDateSearchReportQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;


  constructor(data?: IGetRecDateSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];
      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];

    }
  }

  static fromJS(data: any): GetRecDateSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecDateSearchReportQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;
    return data;
  }

}
export class GetRecDateSearchReportResponse extends SearchReportResponseBase { }



export interface IRecDateSearchListVM {
  recDateSearchRows?: RecDateSearchRowVM[] | undefined;

}

export class RecDateSearchListVM implements IRecDateSearchListVM {
  public recDateSearchRows?: RecDateSearchRowVM[] | undefined;
  constructor(data?: IRecDateSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["recDateSearchRows"])) {
        this.recDateSearchRows = [] as any;
        for (let item of data["recDateSearchRows"])
          this.recDateSearchRows!.push(RecDateSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RecDateSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecDateSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recDateSearchRows)) {
      data["recDateSearchRows"] = [];
      for (let item of this.recDateSearchRows)
        data["recDateSearchRows"].push(item.toJSON());
    }
    return data;
  }

}





export interface IGetRecAddressSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;
}

export class GetRecAddressSearchQuery implements IGetRecAddressSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;

  constructor(data?: IGetRecAddressSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) { 
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.streetName = data["streetName"];
      this.streetNumber = data["streetNumber"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
    }
  }

  static fromJS(data: any): GetRecAddressSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecAddressSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};

    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["streetName"] = this.streetName;
    data["streetNumber"] = this.streetNumber;
    data["towns"] = this.towns; //TODO: test this to make sure it's not a shallow copy
    data["doctypes"] = this.doctypes;
    return data;
  }

}

export interface IRecAddressSearchListVM {
  recAddressSearchRows?: RecAddressSearchRowVM[] | undefined;
}

export class RecAddressSearchListVM implements IRecAddressSearchListVM {
  public recAddressSearchRows?: RecAddressSearchRowVM[] | undefined;
  constructor(data?: IRecAddressSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["recAddressSearchRows"])) {
        this.recAddressSearchRows = [] as any;
        for (let item of data["recAddressSearchRows"])
          this.recAddressSearchRows!.push(RecAddressSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RecAddressSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecAddressSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.recAddressSearchRows)) {
      data["recAddressSearchRows"] = [];
      for (let item of this.recAddressSearchRows)
        data["recAddressSearchRows"].push(item.toJSON());
    }
    return data;
  }

}


export interface IRecAddressSearchRowVM {
  docID?: number | undefined;
  recordDate?: Date | undefined;
  address?: string | undefined;
  cityTown?: string | undefined;
  docType?: string | undefined;
  recLandBook?: string | undefined;
  recLandPage?: string | undefined;
  amount?: number | undefined;
  recLandBP?: string | undefined;
  firstGrantor?: string | undefined;
  firstGrantee?: string | undefined;
  description?: string| undefined;
}
export class RecAddressSearchRowVM implements IRecAddressSearchRowVM {
  
  public docID?: number | undefined;
  public recordDate?: Date | undefined; 
  public address?: string | undefined;
  public cityTown?: string | undefined;
  public docType?: string | undefined;
  public recLandBook?: string | undefined;
  public recLandPage?: string | undefined;
  public amount?: number | undefined;
  public recLandBP?: string | undefined;
  public firstGrantor?: string | undefined;
  public firstGrantee?: string | undefined;
  public description?: string | undefined;
  constructor(data?: IRecAddressSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.docID = data["docID"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.address = data["address"];
    this.cityTown = data["cityTown"];
    this.docType = data["docType"];
    this.recLandBook = data["recLandBook"];
    this.recLandPage = data["recLandPage"];
    this.amount = (data["amount"] as number);
    this.recLandBP = data["recLandBP"];
    this.firstGrantor = data["firstGrantor"];
    this.firstGrantee = data["firstGrantee"];
    this.description = data["description"];
  }

  static fromJS(data: any): RecAddressSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RecAddressSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docID"] = this.docID;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");
    data["address"] = this.address;
    data["cityTown"] = this.cityTown;
    data["docType"] = this.docType;
    data["recLandBook"] = this.recLandBook;
    data["recLandPage"] = this.recLandPage;
    data["amount"] = this.amount;
    data["recLandBP"] = this.recLandBP;
    data["firstGrantor"] = this.firstGrantor;
    data["firstGrantee"] = this.firstGrantee;
    data["description"] = this.description;

  }

}

export interface IRegNameSearchRowVM {
  docID?: number | undefined;

  unparsedName?: string | undefined;

  role?: string | undefined;

  cityTown?: string | undefined;

  recordDate?: Date | undefined;

  docType?: string | undefined;

  docNum?: string | undefined;

  certNum?: string | undefined;
}

export class RegNameSearchRowVM implements IRegNameSearchRowVM {
  docID?: number | undefined;

  unparsedName?: string | undefined;

  role?: string | undefined;

  cityTown?: string | undefined;

  recordDate?: Date | undefined;

  docType?: string | undefined;

  docNum?: string | undefined;

  certNum?: string | undefined;

  constructor(data?: IRegNameSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.docID = data["docID"];
    this.unparsedName = data["unparsedName"];
    this.role = data["role"];
    this.cityTown = data["cityTown"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.docType = data["docType"];
    this.docNum = data["docNum"];
    this.certNum = data["certNum"];
  }

  static fromJS(data: any): RegNameSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegNameSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docID"] = this.docID;
    data["unparsedName"] = this.unparsedName;
    data["role"] = this.role;
    data["cityTown"] = this.cityTown;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");
    data["docType"] = this.docType;
    data["docNum"] = this.docNum;
    data["certNum"] = this.certNum;

  }
}

export interface IRegNameSearchListVM {
  regNameSearchRows?: RegNameSearchRowVM[] | undefined;
}
export class RegNameSearchListVM implements IRegNameSearchListVM {
  regNameSearchRows?: RegNameSearchRowVM[] | undefined;
  constructor(data?: IRegNameSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["regNameSearchRows"])) {
        this.regNameSearchRows = [] as any;
        for (let item of data["regNameSearchRows"])
          this.regNameSearchRows!.push(RegNameSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RegNameSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegNameSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regNameSearchRows)) {
      data["regNameSearchRows"] = [];
      for (let item of this.regNameSearchRows)
        data["regNameSearchRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface IGetRegNameSearchQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
}

export class GetRegNameSearchQuery implements IGetRegNameSearchQuery {
  public lastName?: string | undefined;
  public firstName?: string | undefined;
  public roleId?: number | undefined;
  public fromDate?: string | undefined;
  public toDate?: string | undefined;
  public towns?: string[] | undefined;
  public doctypes?: string[] | undefined;

  constructor(data?: IGetRegNameSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.lastName = data["lastName"];
      this.firstName = data["firstName"];
      this.roleId = data["roleId"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
    }
  }

  static fromJS(data: any): GetRegNameSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegNameSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["roleId"] = this.roleId;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    return data;
  }
}

//export class RegNameSearchRowVM {

//  public docID: number;

//  public unparsedName: string;

//  public role: string;

//  public cityTown: string;

//  public recordDate: Date;

//  public docType: string;

//  public docNum: string;

//  public certNum: string;

//    }

export interface IRegAddressSearchRowVM {
  docID?: number | undefined;

  unparsedAddress?: string | undefined;

  cityTown?: string | undefined;

  recordDate?: Date | undefined;

  docType?: string | undefined;

  docNum?: string | undefined;

  certNum?: string | undefined;

  amount?: number | undefined;

}

export class RegAddressSearchRowVM implements IRegAddressSearchRowVM {
  public docID?: number | undefined;
  
  public unparsedAddress?: string | undefined;

  public cityTown?: string | undefined;

  public recordDate?: Date | undefined;

  public docType?: string | undefined;

  public docNum?: string | undefined;

  public certNum?: string | undefined;

  public amount?: number | undefined;
  constructor(data?: IRegAddressSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.docID = data["docID"];
    this.unparsedAddress = data["unparsedAddress"];
    this.amount = data["amount"];
    this.cityTown = data["cityTown"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.docType = data["docType"];
    this.docNum = data["docNum"];
    this.certNum = data["certNum"];
  }

  static fromJS(data: any): RegAddressSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegAddressSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docID"] = this.docID;
    data["unparsedAddress"] = this.unparsedAddress;
    data["cityTown"] = this.cityTown;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");
    data["docType"] = this.docType;
    data["docNum"] = this.docNum;
    data["certNum"] = this.certNum;
    data["amount"] = this.amount;

  }

}


export interface IRegAddressSearchListVM {
  regAddressSearchRows?: RegAddressSearchRowVM[] | undefined;
}
export class RegAddressSearchListVM implements IRegAddressSearchListVM {
  regAddressSearchRows?: RegAddressSearchRowVM[] | undefined;
  constructor(data?: IRegAddressSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["regAddressSearchRows"])) {
        this.regAddressSearchRows = [] as any;
        for (let item of data["regAddressSearchRows"])
          this.regAddressSearchRows!.push(RegAddressSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RegAddressSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegAddressSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regAddressSearchRows)) {
      data["regAddressSearchRows"] = [];
      for (let item of this.regAddressSearchRows)
        data["regAddressSearchRows"].push(item.toJSON());
    }
    return data;
  }

}
export interface IGetRegAddressSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined
}

export class GetRegAddressSearchQuery implements IGetRegAddressSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined

  constructor(data?: IGetRegAddressSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.streetName = data["streetName"];
      this.streetNumber = data["streetNumber"];
    }
  }

  static fromJS(data: any): GetRegAddressSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegAddressSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["streetName"] = this.streetName;
    data["streetNumber"] = this.streetNumber;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    return data;
  }
}

export interface IRegOwnerSearchRowVM {

  docID?: number | undefined;
  name?: string | undefined;

  docNum?: string | undefined;

  type?: string | undefined;

  cancelledByDoc?: string | undefined;

  cancelledByCert?: string | undefined;

  certNo?: string | undefined;

  book?: string | undefined;

  town?: string | undefined;

  location?: string | undefined;

  certID?: number | undefined;

}

export class RegOwnerSearchRowVM implements IRegOwnerSearchRowVM {

  public docID?: number | undefined;
  public name?: string | undefined;

  public docNum?: string | undefined;

  public type?: string | undefined;

  public cancelledByDoc?: string | undefined;

  public cancelledByCert?: string | undefined;

  public certNo?: string | undefined;

  public book?: string | undefined;

  public town?: string | undefined;

  public location?: string | undefined;

  public certID?: number | undefined;
  constructor(data?: IRegOwnerSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.name = data["name"];
    this.docNum = data["docNum"];
    this.type = data["type"];
    this.cancelledByDoc = data["cancelledByDoc"];
    this.cancelledByCert = data["cancelledByCert"];
    this.certNo = data["certNo"];
    this.book = data["book"];
    this.town = data["town"];
    this.location = data["location"];
    this.certID = data["certID"];
    this.docID = data["docID"];
  }

  static fromJS(data: any): RegOwnerSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegOwnerSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["docNum"] = this.docNum;
    data["type"] = this.type;
    data["cancelledByDoc"] = this.cancelledByDoc;
    data["cancelledByCert"] = this.cancelledByCert;
    data["certNo"] = this.certNo;
    data["book"] = this.book;
    data["town"] = this.town;
    data["location"] = this.location;
    data["certID"] = this.certID;
    data["docID"] = this.docID ;
  }


    }

export interface IGetRegOwnerSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  lastName?: string | undefined;
  firstName?: string | undefined;
}

export class GetRegOwnerSearchQuery implements IGetRegOwnerSearchQuery {
  public fromDate?: string | undefined;
  public toDate?: string | undefined;
  public lastName?: string | undefined;
  public firstName?: string | undefined;
  constructor(data?: IGetRegOwnerSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.firstName = data["firstName"];
      this.lastName = data["lastName"];
    }
  }

  static fromJS(data: any): GetRegOwnerSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegOwnerSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    return data;
  }

}

export interface IGetRegOwnerSearchReportQuery extends IGetRegOwnerSearchQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

}

export class GetRegOwnerSearchReportQuery extends GetRegOwnerSearchQuery implements IGetRegOwnerSearchReportQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

  constructor(data?: IGetRegOwnerSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.firstName = data["firstName"];
      this.lastName = data["lastName"];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.filterExpression = data["filterExpression"];
      this.sortDirection = data["sortDirection"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];

    }
  }

  static fromJS(data: any): GetRegValueSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegValueSearchReportQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["sortyBy"] = this.sortBy;
    data["filterExpression"] = this.filterExpression;
    data["sortDirection"] = this.sortDirection;
    data["filterObjects"] = this.filterObjects;

    return data;
  }


}

export class GetRegOwnerSearchReportResponse extends SearchReportResponseBase { }

export interface IRegOwnerSearchListVM {
  regOwnerSearchRows?: RegOwnerSearchRowVM[] | undefined
}

export class RegOwnerSearchListVM implements IRegOwnerSearchListVM {
  regOwnerSearchRows?: RegOwnerSearchRowVM[] | undefined
  constructor(data?: IRegOwnerSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["regOwnerSearchRows"])) {
        this.regOwnerSearchRows = [] as any;
        for (let item of data["regOwnerSearchRows"])
          this.regOwnerSearchRows!.push(RegOwnerSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RegOwnerSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegOwnerSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regOwnerSearchRows)) {
      data["regOwnerSearchRows"] = [];
      for (let item of this.regOwnerSearchRows)
        data["regOwnerSearchRows"].push(item.toJSON());
    }
    return data;
  }

}

export interface IGetRegValueSearchQuery {
  docCategory?: string[] | undefined;
  amountFrom?: string | undefined;
  amountTo?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  type?: string | undefined;
}

export class GetRegValueSearchQuery implements IGetRegValueSearchQuery {

  docCategory?: string[] | undefined;
  amountFrom?: string | undefined;
  amountTo?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  type?: string | undefined;

  constructor(data?: IGetRegValueSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.docCategory = data["docCategory"];
      this.amountFrom = data["amountFrom"];
      this.amountTo = data["amountTo"];
      this.fromDate = data["fromDate"];
      this.type = data["type"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
    }
  }

  static fromJS(data: any): GetRegValueSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegValueSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docCategory"] = this.docCategory;
    data["amountFrom"] = this.amountFrom;
    data["amountTo"] = this.amountTo;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["type"] = this.type;
    return data;
  }
}

export interface IGetRegValueSearchReportQuery extends IGetRegValueSearchQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

}

export class GetRegValueSearchReportQuery extends GetRegValueSearchQuery implements IGetRegValueSearchReportQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterObjects?: Array<SearchFilter> | undefined;
  filterExpression?: string | undefined;


  constructor(data?: IGetRegValueSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.docCategory = data["docCategory"];
      this.amountFrom = data["amountFrom"];
      this.amountTo = data["amountTo"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.type = data["type"];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.filterExpression = data["filterExpression"];
      this.sortDirection = data["sortDirection"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];

    }
  }

  static fromJS(data: any): GetRegValueSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegValueSearchReportQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docCategory"] = this.docCategory;
    data["amountFrom"] = this.amountFrom;
    data["amountTo"] = this.amountTo;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["type"] = this.type;
    data["sortyBy"] = this.sortBy;
    data["filterExpression"] = this.filterExpression;
    data["sortDirection"] = this.sortDirection;
    data["filterObjects"] = this.filterObjects;

    return data;
  }


}
export class GetRegValueSearchReportResponse extends SearchReportResponseBase { }


export interface IRegValueSearchListVM {
  regValueSearchRows?: RegValueSearchRowVM[] | undefined
}

export class RegValueSearchListVM implements IRegValueSearchListVM {
  regValueSearchRows?: RegValueSearchRowVM[] | undefined
  constructor(data?: IRegValueSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["regValueSearchRows"])) {
        this.regValueSearchRows = [] as any;
        for (let item of data["regValueSearchRows"])
          this.regValueSearchRows!.push(RegValueSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RegValueSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegValueSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regValueSearchRows)) {
      data["regValueSearchRows"] = [];
      for (let item of this.regValueSearchRows)
        data["regValueSearchRows"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPropertySearchListVM {
  propertySearchRows?: PropertySearchRowVM[] | undefined;
}

export class PropertySearchListVM implements IPropertySearchListVM{
  propertySearchRows?: PropertySearchRowVM[] | undefined;

  constructor(data?: IPropertySearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      if (Array.isArray(data["propertySearchRows"])) {
        this.propertySearchRows = [] as any;
        for (let item of data["propertySearchRows"])
          this.propertySearchRows!.push(PropertySearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): PropertySearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new PropertySearchListVM();
    result.init(data);
    return result;
  }



  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.propertySearchRows)) {
      data["propertySearchRows"] = [];
      for (let item of this.propertySearchRows)
        data["propertySearchRows"].push(item.toJSON());
    }
    return data;
  }


}

export interface IPropertySearchRowVM {
  dept?: string | undefined;
  docID?: number | undefined;
  unparsedName?: string | undefined;
  role?: string | undefined;
  recordDate?: Date | undefined;
  address?: string | undefined;
  cityTown?: string | undefined;
  docType?: string | undefined;
  recLandBook?: string | undefined;
  recLandPage?: string | undefined;
  amount?: number | undefined;
  role2?: string | undefined;
  recLandBP?: string | undefined;
  regLandDoc?: string | undefined;
  revParty?: string | undefined;
  description?: string | undefined;
}

export class PropertySearchRowVM implements IPropertySearchRowVM {
  dept?: string | undefined;
  docID?: number | undefined;
  unparsedName?: string | undefined;
  role?: string | undefined;
  recordDate?: Date | undefined;
  address?: string | undefined;
  cityTown?: string | undefined;
  docType?: string | undefined;
  recLandBook?: string | undefined;
  recLandPage?: string | undefined;
  amount?: number | undefined;
  role2?: string | undefined;
  recLandBP?: string | undefined;
  regLandDoc?: string | undefined;
  revParty?: string | undefined;
  description?: string | undefined;

  constructor(data?: IPropertySearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }

    }
  }

  init(data?: any) {
    this.dept = data["dept"]
    this.docID = data["docID"];
    this.unparsedName = data["unparsedName"];
    this.role = data["role"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.address = data["address"];
    this.cityTown = data["cityTown"];
    this.docType = data["docType"];
    this.recLandBook = data["recLandBook"];
    this.recLandPage = data["recLandPage"];
    this.amount = data["amount"];
    this.role2 = data["role2"];
    this.recLandBP = data["recLandBP"];
    this.regLandDoc = data["regLandDoc"];
    this.revParty = data["revParty"];
    this.description = data["description"];
  }

  static fromJS(data: any): PropertySearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new PropertySearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["dept"] = this.dept;
    data["docID"] = this.docID;
    data["unparsedName"] = this.unparsedName;
    data["role"] = this.role;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");
    data["address"] = this.address;
    data["cityTown"] = this.cityTown;
    data["docType"] = this.docType;
    data["recLandBook"] = this.recLandBook;
    data["recLandPage"] = this.recLandPage;
    data["amount"] = this.amount;
    data["role2"] = this.role2;
    data["recLandBP"] = this.recLandBP;
    data["regLandDoc"] = this.regLandDoc;
    data["revParty"] = this.revParty;
    data["description"] = this.description;
    return data;
  }

}

export interface IRegValueSearchRowVM {
  docID?: number | undefined;


  unparsedName?: string | undefined;


  role?: string | undefined;


  cityTown?: string | undefined;
  recordDate?: Date | undefined;


  docType?: string | undefined;


  docNum?: string | undefined;


  certNum?: string | undefined;


}

export class RegValueSearchRowVM implements IRegValueSearchRowVM {

  public docID?: number | undefined;
  public unparsedName?: string | undefined;
  public role?: string | undefined;
  public cityTown?: string | undefined;
  public recordDate?: Date | undefined;
  public docType?: string | undefined;
  public docNum?: string | undefined;
  public certNum?: string | undefined;

  constructor(data?: IRegValueSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    this.docID = data["docID"];
    this.unparsedName = data["unparsedName"];
    this.role = data["role"];
    this.cityTown = data["cityTown"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.docType = data["docType"];
    this.docNum = data["docNum"];
    this.certNum = data["certNum"];
  }
  static fromJS(data: any): RegValueSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegValueSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docID"] = this.docID;
    data["unparsedName"] = this.unparsedName;
    data["role"] = this.role;
    data["cityTown"] = this.cityTown;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");

    data["docType"] = this.docType;
    data["docNum"] = this.docNum;
    data["certNum"] = this.certNum;
    return data;

  }
}

export interface IGetSBImagesQuery {
  emailList?: boolean | undefined;
  emailAddress?: string | undefined;
  zipList?: boolean | undefined;
  sBList?: Array<SBListDTO>;
  credentialGUID?: string | undefined;
  submissionType?: number | undefined;
  internalUserID?: string | undefined;
  internalDescription?: string | undefined;
  optionalPhone?: string | undefined;
  optionalZipCode?: string | undefined;
  authCode?: string | undefined;
  orderId?: string | undefined;
  totalFee?: number | undefined;
  serviceFee?: number | undefined;
  filter?: string | undefined;
  units?: number | undefined;
}

export class GetSBImagesQuery implements IGetSBImagesQuery {
  public emailList?: boolean | undefined;
  public emailAddress?: string | undefined;
  public zipList?: boolean | undefined;
  public sBList?: SBListDTO[] | undefined;
  public credentialGUID?: string | undefined;
  public submissionType?: number | undefined;
  public internalUserID?: string | undefined;
  public internalDescription?: string | undefined;
  public optionalPhone?: string | undefined;
  public optionalZipCode?: string | undefined;
  public authCode?: string | undefined;
  public orderId?: string | undefined;
  public totalFee?: number | undefined;
  public serviceFee?: number | undefined;
  public filter?: string | undefined;
  public units?: number | undefined;


  constructor(data?: IGetSBImagesQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    this.emailList = data["emailList"];
    this.emailAddress = data["emailAddress"];
    this.zipList = data["zipList"];
    if (Array.isArray(data["sBList"])) {
      this.sBList = [] as any;
      for (let item of data["sBList"])
        this.sBList!.push(SBListDTO.fromJS(item));
    }
    this.credentialGUID = data["credentialGUID"];
    this.submissionType = data["submissionType"];
    this.internalUserID = data["internalUserID"];
    this.internalDescription = data["internalDescription"];
    this.optionalPhone = data["optionalPhone"];
    this.optionalZipCode = data["optionalZipCode"];
    this.authCode = data["authCode"];
    this.orderId = data["orderId"];
    this.totalFee = data["totalFee"];
    this.serviceFee = data["serviceFee"];
    this.filter = data["filter"];
    this.units = data["units"];
  }
  static fromJS(data: any): GetSBImagesQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetSBImagesQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailList"] = this.emailList;
    data["emailAddress"] = this.emailAddress;
    data["zipList"] = this.zipList;
    if (Array.isArray(this.sBList)) {
      data["sBList"] = [];
      for (let item of this.sBList)
        data["sBList"].push(item.toJSON());
    }
    data["credentialGUID"] = this.credentialGUID;
    data["submissionType"] = this.submissionType;
    data["internalUserID"] = this.internalUserID;
    data["internalDescription"] = this.internalDescription;
    data["optionalPhone"] = this.optionalPhone;
    data["optionalZipCode"] = this.optionalZipCode;
    data["authCode"] = this.authCode;
    data["orderId"] = this.orderId;
    data["totalFee"] = this.totalFee;
    data["serviceFee"] = this.serviceFee;
    data["filter"] = this.filter;
    data["units"] = this.units;
    return data;

  }
}

export interface ISBListDTO {
  imageType?: string | undefined; //pdf = PDF, tif = TIFF
  department?: string | undefined; //R = recorded land, L = registered land
  bookDoc?: string | undefined;
  bookPage?: string | undefined;
  pages?: string[] | undefined;
  wholeDoc?: boolean | undefined;
  docType?: string | undefined;
  docPageCount?: number | undefined;
  desc?: string | undefined;
}

export class SBListDTO implements ISBListDTO {
  public imageType?: string | undefined; //pdf = PDF, tif = TIFF
  public department?: string | undefined; //R = recorded land, L = registered land
  public bookDoc?: string | undefined;
  public bookPage?: string | undefined;
  public pages?: Array<string> | undefined;
  public wholeDoc?: boolean | undefined;
  public docType?: string | undefined;
  public docPageCount?: number | undefined;
  public desc?: string | undefined;

  constructor(data?: ISBListDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.imageType = data["imageType"];
    this.department = data["department"];
    this.bookDoc = data["bookDoc"];
    this.bookPage = data["bookPage"];
    if (Array.isArray(data["pages"])) {
      this.pages = [];
      for (let item of data["pages"])
        this.pages!.push(item);
    }

    this.wholeDoc = data["wholeDoc"];
    this.docType = data["docType"];
    this.docPageCount = data["docPageCount"];
    this.desc= data["desc"];
  }
  static fromJS(data: any): SBListDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SBListDTO();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["imageType"] = this.imageType;
    data["department"] = this.department;
    data["bookDoc"] = this.bookDoc;
    data["bookPage"] = this.bookPage;
    if (Array.isArray(this.pages)) {
      data["pages"] = [];
      for (let item of this.pages)
        data["pages"].push(item);
    }

    data["wholeDoc"] = this.wholeDoc;
    data["docType"] = this.docType;
    data["docPageCount"] = this.docPageCount;
    data["desc"] = this.desc;
    return data;

  }


}


    export class InstrumentVM {
        
        // $LoudName
        public docID: number ;
        // $LoudName
        public primaryID: string ;
        // $LoudName
        public secondaryID: string ;
        // $LoudName
        public docType: string ;
        // $LoudName
        public recDate: Date ;
        // $LoudName
        public docSource: string ;
        // $LoudName
        public docFormat: string ;
        // $LoudName
      public pageCount: number;

      public docBPGroup: string;
      public descript: string;

}

export class CertificateVM {
  public certID: number;
  public certNum: string;
  public certAction: string;
}
    export class PartyVM {
        
        // $LoudName
        public typeFlag: string ;
        // $LoudName
        public lastCorpName: string ;
        // $LoudName
        public fName: string ;
        // $LoudName
        public seq: number ;
        // $LoudName
        public role: string ;
    }
    export class UnparsedAddressVM {
        
        // $LoudName
        public address: string ;
    }
    export class RecDocVM {
        
        // $LoudName
      public docID: number;
      // $LoudName
      public address: string;
        // $LoudName
        public docDetail: InstrumentVM ;
        // $LoudName
        public docTors: PartyVM[] ;
        // $LoudName
        public docTees: PartyVM[] ;
        // $LoudName
        public docRefTo: InstrumentVM[] ;
        // $LoudName
        public docRefBy: InstrumentVM[] ;
        // $LoudName
        public docAddress: UnparsedAddressVM[];
        // $LoudName
        public docTrans: InstrumentVM[];

     
}
export class RegDocVM {
  // $LoudName
  public docID: number;
  // $LoudName
  public docDetail: InstrumentVM;
  // $LoudName
  public docTors: PartyVM[];
  // $LoudName
  public docTees: PartyVM[];
  // $LoudName
  public docRefTo: InstrumentVM[];
  // $LoudName
  public docRefBy: InstrumentVM[];
  // $LoudName
  public docAddress: UnparsedAddressVM[];
  // $LoudName
  public docTrans: InstrumentVM[];
  // $LoudName
  public docCerts: CertificateVM[];
}

export interface IRegDateSearchRowVM {
  docID?: number | undefined;


  unparsedName?: string | undefined;


  role?: string | undefined;


  cityTown?: string | undefined;
  recordDate?: Date | undefined;


  docType?: string | undefined;


  docNum?: string | undefined;


  certNum?: string | undefined;

}
export class RegDateSearchRowVM implements IRegDateSearchRowVM {


  public docID?: number | undefined;
  public unparsedName?: string | undefined;
  public role?: string | undefined;
  public cityTown?: string | undefined;
  public recordDate?: Date | undefined;
  public docType?: string | undefined;
  public docNum?: string | undefined;
  public certNum?: string | undefined;

  constructor(data?: IRegDateSearchRowVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    this.docID = data["doC_ID"];
    this.unparsedName = data["unparsedName"];
    this.role = data["role"];
    this.cityTown = data["cityTown"];
    this.recordDate = new Date();
    this.recordDate.setTime(Date.parse(data["recordDate"]));//TODO: test
    this.docType = data["docType"];
    this.docNum = data["docNum"];
    this.certNum = data["certNum"];
  }
  static fromJS(data: any): RegDateSearchRowVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegDateSearchRowVM();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["doC_ID"] = this.docID;
    data["unparsedName"] = this.unparsedName;
    data["role"] = this.role;
    data["cityTown"] = this.cityTown;
    data["recordDate"] = formatDate(this.recordDate, "shortDate");

    data["docType"] = this.docType;
    data["docNum"] = this.docNum;
    data["certNum"] = this.certNum;
    return data;

  }


}

export interface IGetRegDateSearchQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
}

export class GetRegDateSearchQuery implements IGetRegDateSearchQuery {
  public fromDate?: string | undefined;
  public toDate?: string | undefined;
  public towns?: string[] | undefined;
  public doctypes?: string[] | undefined;

  constructor(data?: IGetRegDateSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
    }
  }

  static fromJS(data: any): GetRegDateSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegDateSearchQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    return data;
  }

}

export interface IGetRegDateSearchReportQuery extends IGetRecDateSearchReportQuery { }

export class GetRegDateSearchReportQuery extends GetRegDateSearchQuery implements IGetRegDateSearchReportQuery {
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;

  constructor(data?: IGetRegDateSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];

      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];

    }
  }

  static fromJS(data: any): GetRegDateSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegDateSearchReportQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;
    return data;
  }

}

export class GetRegDateSearchReportResponse extends SearchReportResponseBase { }

export interface IRegDateSearchListVM {
  regDateSearchRows?: RegDateSearchRowVM[] | undefined;

}

export class RegDateSearchListVM implements IRegDateSearchListVM {
  public regDateSearchRows?: RegDateSearchRowVM[] | undefined;
  constructor(data?: IRegDateSearchListVM) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (Array.isArray(data["regDateSearchRows"])) {
        this.regDateSearchRows = [] as any;
        for (let item of data["regDateSearchRows"])
          this.regDateSearchRows!.push(RegDateSearchRowVM.fromJS(item));
      }
    }
  }
  static fromJS(data: any): RegDateSearchListVM {
    data = typeof data === 'object' ? data : {};
    let result = new RegDateSearchListVM();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.regDateSearchRows)) {
      data["regDateSearchRows"] = [];
      for (let item of this.regDateSearchRows)
        data["regDateSearchRows"].push(item.toJSON());
    }
    return data;
  }

}

export class RegMemoEncumRowVM {

  public docNum: string;

  public docID: number; 


  public docCode: string;


  public certID: number; 


  public certNum: string; 


  public encumID: number; 


  public inFavorOf: string;

  //public DOC_ID_TERM_BY: number; 


  public terms: string; 

 

  public dischComment: string; 


  public signedDate: Date;

  public dateReg: Date; 


  public dischDocNum: string;
  public discdocID: number;

  public discDate: Date;

  //public DOC_TYPE_ID: number; 
}

export interface IGetLCCertTextQuery {
  certId?: number | undefined;
  linkName?: string | undefined;
}

export class GetLCCertTextQuery implements IGetLCCertTextQuery {
  public certId?: number | undefined;
  public linkName?: string | undefined;

  constructor(data?: IGetLCCertTextQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.certId = data["certId"];
      this.linkName = data["linkName"];
    }
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["certId"] = this.certId;
    data["linkName"] = this.linkName;
    return data;
  }

}

export class GetRecAddressSearchReportResponse extends SearchReportResponseBase { }

export interface IGetRecNameSearchReportResponse {
  reportName?: string | undefined;
}
export class GetRecNameSearchReportResponse implements IGetRecNameSearchReportResponse {
  public reportName?: string | undefined;

  constructor(data?: IGetRecNameSearchReportResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.reportName = data["reportName"];
  }
  static fromJS(data: any): GetRecNameSearchReportResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecNameSearchReportResponse();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportName"] = this.reportName;
  }
}


export interface IGetRecValueSearchQuery {
  docCategory?: string[] | undefined;
  amountFrom?: string | undefined;
  amountTo?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  type?: string | undefined;
}

export class GetRecValueSearchQuery implements IGetRecValueSearchQuery {
  docCategory?: string[] | undefined;
  amountFrom?: string | undefined;
  amountTo?: string | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  type?: string | undefined;
  constructor(data?: IGetRecValueSearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.docCategory = data["docCategory"];
      this.amountFrom = data["amountFrom"];
      this.amountTo = data["amountTo"];
      this.fromDate = data["fromDate"];
      this.type = data["type"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
    }
  }

  static fromJS(data: any): GetRecValueSearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecValueSearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docCategory"] = this.docCategory;
    data["amountFrom"] = this.amountFrom;
    data["amountTo"] = this.amountTo;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["type"] = this.type;
    return data;
  }

}
export interface IGetRecValueSearchReportQuery extends IGetRecValueSearchQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filtersCollection?: string[] | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

}

export class GetRecValueSearchReportQuery extends GetRecValueSearchQuery implements IGetRecValueSearchReportQuery {
  sortBy?: string[] | undefined;
  filterExpression?: string | undefined;
  sortDirection?: string | undefined;
  filtersCollection?: string[] | undefined;
  filterObjects?: Array<SearchFilter> | undefined;

  constructor(data?: IGetRecValueSearchReportQuery) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.docCategory = data["docCategory"];
      this.amountFrom = data["amountFrom"];
      this.amountTo = data["amountTo"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.type = data["type"];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.filterExpression = data["filterExpression"];
      this.sortDirection = data["sortDirection"];
      this.filtersCollection = [...(data["filtersCollection"] as string[])];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    }
  }

  static fromJS(data: any): GetRecValueSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecValueSearchReportQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["docCategory"] = this.docCategory;
    data["amountFrom"] = this.amountFrom;
    data["amountTo"] = this.amountTo;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["type"] = this.type;
    data["sortyBy"] = this.sortBy;
    data["filterExpression"] = this.filterExpression;
    data["sortDirection"] = this.sortDirection;
    data["filtersCollection"] = this.filtersCollection;
    data["filterObjects"] = this.filterObjects;
    return data;
  }


}
export class GetRecValueSearchReportResponse extends SearchReportResponseBase { }

export interface ISearchFilter {
  fieldName?: string | undefined;
  fieldType?: string | undefined;
  filterType?: string | undefined;
  filterValue?: string | undefined;
  filters?: SearchFilter[] | undefined;
}
export class SearchFilter implements ISearchFilter {
  fieldName?: string | undefined;
  fieldType?: string | undefined;
  filterType?: string | undefined;
  filterValue?: string | undefined;
  filters?: SearchFilter[] | undefined;

  constructor(data?: ISearchFilter) {
    if (data) {
      this.fieldName = data["fieldName"];
      this.filterType = data["filterType"];
      this.filterValue = data["filterValue"];
      this.fieldType = "";
      this.filters = new Array<SearchFilter>();
    }
  }

  static fromJS(data: any): SearchFilter {
    data = typeof data === 'object' ? data : {};
    let result = new SearchFilter();
    result.init(data);
    return result;

  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fieldName"] = this.fieldName;
    data["filterType"] = this.filterType;
    data["fieldType"] = this.fieldType;
    data["filterValue"] = this.filterValue;
    data["filters"] = [...this.filters];
    return data;
  }

  static subHelper(data: any, depth): SearchFilter[] {
    if (data) {
      console.log(`=======================subHelper call at depth ${depth}`);
      console.log(`data at depth ${depth}: ${JSON.stringify(data)}`);
      console.log(`data[0] at depth ${depth}: ${JSON.stringify(data[0])}`);
      let result = new Array<SearchFilter>();
      if (typeof data === 'string' && (data == 'and' || data == 'or')) {
        let join = new SearchFilter({ filterType: 'join', filterValue: data, fieldName: data, fieldType: data });
        result.push(join);
        return result;
      }

      if (typeof data[0] === 'object') {
        for (var d of data) {
          depth = depth + 1;
          var r1 = SearchFilter.subHelper(d, depth);
          console.log(`r1 at ${--depth}: ${JSON.stringify(r1)}`);
          //if (depth == 0) {
          //  result = [...result, ...r1];
          //} else {
          //  result = [...r1];
          //}
          //if (depth == 0) {

            //  if (r1.length > 1) {
            //consolidate
            if (r1.length == 3) {
              var join = r1[1];
              join.filters.push(r1[0]);
              join.filters.push(r1[2]);
              result.push(join);

            } else {
              result = [...result, ...r1];

            }

          //} else {
          //  result = [...result, ...r1];
          //}

        }
      } else {
        let filter = SearchFilter.fromJS(data);
        result.push(filter);

        //if (data[0] !== 'and' && data[0] !== 'or') {
        //  //we have a filter
        //  let filter = SearchFilter.fromJS(data);
        //  result.push(filter);
        //} else {
        //  let join = new SearchFilter({ filterType: 'join', filterValue: data[0], fieldName: data[0], fieldType: data[0] });
        //  result.push(join);
        //}
      }

      //console.log(`result at depth ${depth}: ${JSON.stringify(result)}`);
      return result;
      
    }
  }

  static subFromJSs(data: any): SearchFilter[] {
    if (data) {
      var results = new Array<SearchFilter>();
      let root = new SearchFilter();
      for (var d of data) {

        let r = SearchFilter.subHelper(d, 0);
        if (r.length > 1) {
          //consolidate
          if (r.length == 3) {
            var join = r[1];
            join.filters.push(r[0]);
            join.filters.push(r[2]);
            results.push(join);
          }
        } else {
          results = [...results, ...r];

        }
        console.log(`results for ${JSON.stringify(d)} at depth 0: ${JSON.stringify(results)}`);

      }
      return results;
    }
  }
  static fromJSs(data: any): SearchFilter[] {
    if (data) {

      var result = new Array<SearchFilter>();
      if (typeof data[0] === 'object') {
        for (var d1 of data[0]) {
          if (typeof d1 === 'string') {
            if (d1 != 'and' && d1 != 'or') {
              //we have a filter
              let r1 = SearchFilter.fromJS(data[0]);
              result.push(r1);
              break;
            } else {
              let join = new SearchFilter({ filterType: d1, filterValue: d1, fieldName: d1, fieldType: d1 });
              result.push(join);
            }
          } else if (typeof d1 === 'object') {
            //next level
            var r1 = SearchFilter.fromJSs(d1);
          }
        }
      }
      //data = typeof data === 'object' ? data : {};
      //var result = new Array<SearchFilter>();
      //if (typeof data[0] === 'string') {
      //  //we either have a SearchFilter object we want to parse
      //  //or we have a joining word like And or Or
      //  if (data[0] != 'and' && data[0] != "or") {
      //    let r = SearchFilter.fromJS(data);
      //    result.push(r);
      //  } else {
      //    if (data[0] == 'and' || data[0] == 'or') {
      //      let joinObj = new SearchFilter({ fieldName: data[0], fieldType: "join", filterType: data[0], filterValue: data[0] });
      //      result.push(joinObj);
      //    }
      //  }
      //} else {
      //  //if it's another object
      //  if (typeof data[0] === 'object') {
      //    //recursive step
      //  }
      //}
      //if (typeof data[0] !== 'object') {
      //  console.log(`-----------inside fromJSs`);
      //  let r = SearchFilter.fromJS(data);
      //  result.push(r);
      //} else {
      //  //for (var d of data) {
      //  //  console.log(`type of d: ${typeof d}`);
      //  //  console.log(`d: ${JSON.stringify(d)}`);

      //  //  if (typeof d === 'object') {
      //  //    let r = new SearchFilter();
      //  //    r.init(d);
      //  //    result.push(r);
      //  //  }
      //  //}
      //  //for (var d of data) {
      //    SearchFilter.fromJShelper(data, result);

      //  //}
      //}
      return result;
    }
  }
  private static fromJShelper(data: any, result: SearchFilter[]) {
    console.log(`type of data: ${typeof data}`);
    console.log(`data: ${JSON.stringify(data)}`);

    if (typeof data === 'string' && data == 'and') return;

    if (typeof data[0] === 'object') {
      for (var x of data) {
        this.fromJShelper(x, result);
      }

    } else {
      let r = new SearchFilter();
      r.init(data);
      result.push(r);
      return;

    }
  }
  init(data: any) {
    if (data) {
      this.fieldName = data[0];
      this.filterType = data[1];
      this.filterValue = data[2];
      this.fieldType = "";
      this.filters = new Array<SearchFilter>();

    }
  }
}

export class GetRegNameSearchReportResponse extends GetRecNameSearchReportResponse { }

export interface IGetRecNameSearchReportQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;
}

export class GetRecNameSearchReportQuery implements IGetRecNameSearchReportQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;


  constructor(data?: IGetRecNameSearchReportQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.lastName = data["lastName"];
      this.firstName = data["firstName"];
      this.roleId = data["roleId"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];
      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    }
  }

  static fromJS(data: any): GetRecNameSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecNameSearchReportQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["roleId"] = this.roleId;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;
    return data;
  }
}

export interface IGetRegAddressSearchReportResponse {
  reportName?: string | undefined;
}
export class GetRegAddressSearchReportResponse implements IGetRegAddressSearchReportResponse {
  public reportName?: string | undefined;

  constructor(data?: IGetRegAddressSearchReportResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    this.reportName = data["reportName"];
  }
  static fromJS(data: any): GetRegAddressSearchReportResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegAddressSearchReportResponse();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["reportName"] = this.reportName;
  }
}

export interface IGetRegAddressSearchReportQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;
}

export class GetRegAddressSearchReportQuery implements IGetRegAddressSearchReportQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;


  constructor(data?: IGetRegAddressSearchReportQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.streetNumber = data["streetNumber"];
      this.streetName = data["streetName"];
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];
      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    }
  }
  static fromJS(data: any): GetRegAddressSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegAddressSearchReportQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["streetNumber"] = this.streetNumber;
    data["doctypes"] = this.doctypes;
    data["streetName"] = this.streetName;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;
    return data;
  }

}



export interface IGetRecAddressSearchReportQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;
}

export class GetRecAddressSearchReportQuery implements IGetRecAddressSearchReportQuery {
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  streetNumber?: string | undefined;
  streetName?: string | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection?: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;

  constructor(data?: IGetRecAddressSearchReportQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) {
          (<any>this)[property] = (<any>data)[property];
        }
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];
      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.streetNumber = data["streetNumber"];
      this.streetName = data["streetName"];
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];
      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];
    }
  }
  static fromJS(data: any): GetRecAddressSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRecAddressSearchReportQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["streetNumber"] = this.streetNumber;
    data["doctypes"] = this.doctypes;
    data["streetName"] = this.streetName;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;
    return data;
  }

}

export interface IGetRegNameSearchReportQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;

}
export class GetRegNameSearchReportQuery implements IGetRegNameSearchReportQuery {
  lastName?: string | undefined;
  firstName?: string | undefined;
  roleId?: number | undefined;
  fromDate?: string | undefined;
  toDate?: string | undefined;
  towns?: string[] | undefined;
  doctypes?: string[] | undefined;
  sortBy?: string[] | undefined;
  sortDirection: string | undefined;
  filterExpression?: string | undefined;
  filterObjects?: SearchFilter[] | undefined;


  constructor(data?: IGetRegNameSearchReportQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }
  init(data?: any) {
    if (data) {
      this.lastName = data["lastName"];
      this.firstName = data["firstName"];
      this.roleId = data["roleId"];
      this.fromDate = data["fromDate"];
      this.toDate = data["toDate"];

      this.towns = [...(data["towns"] as string[])]; //TODO: test this to make sure it's not a shallow copy
      this.doctypes = [...(data["doctypes"] as string[])];
      this.sortBy = [...(data["sortBy"] as string[])];
      this.sortDirection = data["sortDirection"];

      this.filterExpression = data["filterExpression"];
      this.filterObjects = [...(data["filterObjects"]) as SearchFilter[]];

    }
  }

  static fromJS(data: any): GetRegNameSearchReportQuery {
    data = typeof data === 'object' ? data : {};
    let result = new GetRegNameSearchReportQuery();
    result.init(data);
    return result;
  }
  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["lastName"] = this.lastName;
    data["firstName"] = this.firstName;
    data["roleId"] = this.roleId;
    data["fromDate"] = this.fromDate;
    data["toDate"] = this.toDate;
    data["towns"] = this.towns;
    data["doctypes"] = this.doctypes;
    data["sortyBy"] = this.sortBy;
    data["sortDirection"] = this.sortDirection;
    data["filterExpression"] = this.filterExpression;
    data["filterObjects"] = this.filterObjects;

    return data;
  }
}
